import { Heading } from 'Components/shared/Heading';
import React, { useState } from 'react';
import { Button } from '~/lib/ui/button';
import { AudioTestModal } from './AudioTestModal';
import { StunTestModal } from './StunTestModal';

export const AdvancedSettings: React.FC = () => {
  const [isStunTestOpen, setIsStunTestOpen] = useState(false);
  const [isAudioTestOpen, setIsAudioTestOpen] = useState(false);

  return (
    <>
      <div>
        <Heading variant="h2">Advanced settings</Heading>
        <div className="semantic-flex-column semantic-flex-justify-space-between settings-general--wrapper">
          <div>
            <div className="mt-[25px]">
              <Heading variant="h3">Network Diagnostics</Heading>
              <div>
                Test STUN connectivity and NAT traversal for VoIP calls. Results
                are automatically sent to support team.
              </div>
              <Button
                onClick={() => setIsStunTestOpen(true)}
                size="lg"
                className="mt-2"
              >
                Run STUN Test
              </Button>
            </div>

            <div className="mt-[25px]">
              <Heading variant="h3">Audio Device Diagnostics</Heading>
              <div>
                Test microphone access, speaker enumeration, and audio device
                functionality. Detects <code>setSinkId</code> errors and
                permission issues.
              </div>
              <Button
                onClick={() => setIsAudioTestOpen(true)}
                size="lg"
                className="mt-2"
              >
                Run Audio Test
              </Button>
            </div>
          </div>
        </div>
      </div>

      <StunTestModal
        isOpen={isStunTestOpen}
        onClose={() => setIsStunTestOpen(false)}
      />
      <AudioTestModal
        isOpen={isAudioTestOpen}
        onClose={() => setIsAudioTestOpen(false)}
      />
    </>
  );
};
